import React from "react";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import TotalReceivingUnitsForm from "./TotalReceivingUnitsForm";

export default function TotalReceivingUnitsModal({
  title,
  value,
  typeLabel,
  quantityLabel,
  addLabel,
  onClose,
  onSave,
  typeKey,
  quantityKey,
  typeOptions,
}) {
  return (
    <Dialog
      open
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: "500px", maxWidth: "100%" } }}
    >
      <DialogContent>
        <DialogContentText>
          <Box mt={3} mb={4}>
            <Typography color="text.secondary" variant="h2" align="center">
              {title}
            </Typography>
          </Box>
          <Box mx={{ xs: -2, sm: 0 }}>
            <TotalReceivingUnitsForm
              value={value}
              typeLabel={typeLabel}
              quantityLabel={quantityLabel}
              addLabel={addLabel}
              onClose={onClose}
              onSave={onSave}
              typeKey={typeKey}
              quantityKey={quantityKey}
              typeOptions={typeOptions}
            />
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
